/**
 * @copyright 2019 @ DigiNet
 * @author tranghoang
 * @create 2017/10/25 16:37
 * @update 2017/10/25 16:37
 * @file src/components/not-found/not-found.js
 */

import React, {Component} from 'react';
import Config from "../../config";
import {FormGroup, Col} from "reactstrap"
import {browserHistory} from "react-router";

export default class ModuleNotFound extends Component {


    render() {

        return (
            <div className="error-page login mrgt50">
                <img
                    src={require('./../../assets/images/icon-not-found.png')}
                    alt="" width={265} height={265}/>
                <FormGroup row className="text-center">
                    <Col>
                        <h2>{Config.lang("ERP_Khong_tim_thay_trang")}</h2>
                    </Col>
                    <Col>
                        {Config.lang("ERP_404_loi")}
                    </Col>
                </FormGroup>
                {/*{Config.lang("ERP_Chuc_nang_dang_duoc_phat_trien")}..*/}
                {/* eslint-disable */}
                <a onClick={()=>{
                    browserHistory.push({
                        pathname: Config.getRootPath() + 'dashboard',
                        state: {
                            mode: 'MSS'
                        }
                    })
                }}>
                    {Config.lang("ERP_Trang_chu")}
                </a>
                {/* eslint-enable */}
            </div>
        )
    }
}
